export enum LoanStatusColors {
  RED = 'red',
  YELLOW = 'yellow',
  GREEN = 'green',
}
